import useTenantQuery from '@/hooks/useTenantQuery';
import tenant from '@/services/TenantService';
import {
  Box,
  TextField,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  Chip,
} from '@mui/material';
import { useState } from 'react';
import { toast } from 'react-toastify';

export default function TenantProfilesDetail({ data }) {
  const { data: roles } = useTenantQuery('role');
  const { data: teams } = useTenantQuery('team');

  const [accountData, setAccountData] = useState({
    email: data?.email,
    firstName: data?.firstName,
    lastName: data?.lastName,
    mobilePhone: data?.mobilePhone,
    jobTitle: data?.jobTitle,
    teams: data?.teams || [],
    role: data?.role || '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAccountData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleTeamsChange = (event) => {
    const { value } = event.target;
    setAccountData(prev => ({
      ...prev,
      teams: value
    }));
  };

  const saveAccountData = async () => {
    const updateObject = {
      firstName: accountData.firstName,
      lastName: accountData.lastName,
      mobilePhone: accountData.mobilePhone,
      jobTitle: accountData.jobTitle,
      teams: accountData.teams, 
      role: accountData.role,   
    };
    try {
      await tenant.put(`/user/${data._id}`, updateObject);
      toast.success('Account wurde erfolgreich aktualisiert');
    } catch (e) {
      toast.error(e?.response?.data?.message);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        width: '100%',
        height: '100%',
      }}
    >
      <TextField
        fullWidth
        label="E-Mail"
        name="email"
        value={accountData.email}
        variant="outlined"
        margin="normal"
        onChange={handleChange}
      />
      <TextField
        fullWidth
        label="Vorname"
        name="firstName"
        value={accountData.firstName}
        variant="outlined"
        margin="normal"
        onChange={handleChange}
      />
      <TextField
        fullWidth
        label="Nachname"
        name="lastName"
        value={accountData.lastName}
        variant="outlined"
        margin="normal"
        onChange={handleChange}
      />
      <TextField
        fullWidth
        label="Mobiltelefon"
        name="mobilePhone"
        value={accountData.mobilePhone}
        variant="outlined"
        margin="normal"
        onChange={handleChange}
      />
      <TextField
        fullWidth
        label="Jobbezeichnung"
        name="jobTitle"
        value={accountData.jobTitle}
        variant="outlined"
        margin="normal"
        onChange={handleChange}
      />
      <FormControl fullWidth sx={{ m: 1 }}>
        <InputLabel id="teams-chip-label">Teams</InputLabel>
        <Select
          labelId="teams-chip-label"
          id="teams-chip"
          multiple
          value={accountData.teams}
          onChange={handleTeamsChange}
          input={<OutlinedInput id="select-multiple-chip" label="Teams" />}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((teamId) => {
                const team = teams?.find(t => t._id === teamId);
                return team ? (
                  <Chip key={teamId} label={team.title} />
                ) : null;
              })}
            </Box>
          )}
        >
          {teams?.map((team) => (
            <MenuItem key={team._id} value={team._id}>
              {team.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        select
        fullWidth
        label="Rolle"
        name="role"
        value={accountData.role}
        variant="outlined"
        margin="normal"
        onChange={handleChange}
      >
        {roles?.map((role) => (
          <MenuItem key={role._id} value={role._id}>
            {role.name}
          </MenuItem>
        ))}
      </TextField>
      <Button
        sx={{ mt: '5px' }}
        fullWidth
        variant="contained"
        onClick={saveAccountData}
      >
        Speichern
      </Button>
    </Box>
  );
}
